export default "__VITE_ASSET__qQWGbMQo__"